import { Crop } from 'react-image-crop';

interface Rect {
	width: number;
	height: number;
}

interface Bounds extends Rect {
	x: number;
	y: number;
}

interface ImageResizeFrame {
	source: Bounds;
	destination: Bounds;
}

export default class ImageService {
	static createImageResizeFrame(
		elementCrop: Crop | undefined,
		elementRect: Rect,
		naturalImageRect: Rect,
	): ImageResizeFrame {
		const scaleX = naturalImageRect.width / elementRect.width;
		const scaleY = naturalImageRect.height / elementRect.height;

		const cropHeight = elementCrop?.height ?? 0;
		const cropWidth = elementCrop?.width ?? 0;

		return {
			source: {
				x: Math.round((elementCrop?.x ?? 0) * scaleX),
				y: Math.round((elementCrop?.y ?? 0) * scaleY),
				width: Math.round(cropWidth * scaleX),
				height: Math.round(cropHeight * scaleY),
			},
			destination: {
				x: 0,
				y: 0,
				width: Math.round(cropWidth * scaleX),
				height: Math.round(cropHeight * scaleY),
			},
		};
	}
}
